import { useContext } from 'react';
import { RouteTransitionContext } from '../../context/RouteTransitionContext';

// Intentionally does NOT throw on a missing provider: the transition overlay is
// logged-in only (provider lives in LoggedInLayout). Logged-out pages (login,
// pending, error) render PageLayout without it and fall back to the default
// (not transitioning) instead of crashing.
export const useRouteTransitionContext = () =>
  useContext(RouteTransitionContext);
